import React, { Component } from "react"
import ExchangeBoard from './exchangeBoard.js';
import Container from 'react-bootstrap/Container'
import LeftHandPanel from './leftHandPanel.js'
import CollapsibleList from './collapsible.js'
import RightTable from './rightTable.js'
import Row from 'react-bootstrap/Row'
import Col from 'react-bootstrap/Col'
import { ScrollTo, ScrollArea } from "react-scroll-to"
import { Grid } from 'gymnast'
import store from "./store/index"
import date from "../node_modules/date-and-time"
import { getTimeDiffInMins } from "./support.js"
import moment from 'moment';
import { getTimeinHHMMFormat } from "./support.js"
import { getRealTimeinHHMMFormat } from "./support.js"
import { updateBetMarket, updateAiRankStats } from "./actions";

import axios from 'axios';

const API2 = 'https://rpmapi.makebettinggreat.com/v1/horse/odds';
const API_WINNER = 'https://rpmapi.makebettinggreat.com/v1/horse/winners/';
const API_AI_RANK_STATS = 'https://rpmapi.makebettinggreat.com/v1/horse/ai-rank-stats/';

const headStyle1 = {
  color: 'white',
  fontSize: '20px',
  marginLeft: '20px',
  fontfamily: 'Segoe UI'
};

const anyClass = {
  height: '150px',
  overflowy: 'scroll'
}
const verAlign = {
  margin: 'auto',
  width: '100%',
  height: '100%',
  border: '3px solid #73AD21',
  color: 'white'

}

var responseBody = {
  "marketOdds": []
}

const currentRaceProps = {
  curRace: null,
  curRacers: null,
}

const postRequestPara = {
  "marketIds": [
    "1.156717370"
  ],
  "timePoints": [
    "t1-20190329-13:55:00",
    "t2-20190329-14:10:00",
    "t3-20190329-14:40:00",
    "t4-20190329-14:45:00",
    "t5-20190329-14:50:00",
    "t6-20190329-14:55:00"
  ]
}

// Returns the Betfair tick size for a given price (official exchange ladder)
function getTickSize(price) {
  if (price < 2)   return 0.01
  if (price < 3)   return 0.02
  if (price < 4)   return 0.05
  if (price < 6)   return 0.1
  if (price < 10)  return 0.2
  if (price < 20)  return 0.5
  if (price < 30)  return 1
  if (price < 50)  return 2
  if (price < 100) return 5
  return 10
}

class CurrencyBoard extends Component {
  defaultTimer = 15000;
  winnerTimerSetting = 60000;
  highSpeedTimer = 3000;
  timer = null;
  winnerTimer = null;
  intensiveMode = false;
  INTENSE_MINUTE_SETTING = 3;

  constructor(props) {
    super(props)
    this.state = {
      currentRace: { time: "", venue: "" },
      predictions: {},
      currentRacers: {},
      runnersOddsAtTimes: [],
      marketInfos: {},
      winnerInfo: null,
      marketId: null,
      verdict: null
    }
    this.updateBoards = this.updateBoards.bind(this)
    this.getRunnerName = this.getRunnerName.bind(this)
    this.requestTimeOdds = this.requestTimeOdds.bind(this)
    this.requestWinnerInfo = this.requestWinnerInfo.bind(this)
    this.requestVerdict = this.requestVerdict.bind(this)

    if (props.tabSelected === "RacesNRunners") {
      if (currentRaceProps.curRace !== null) {
        this.requestTimeOdds(currentRaceProps.curRace, currentRaceProps.curRacers)
        this.requestWinnerInfo(currentRaceProps.curRace)
      }
      this.timer = setInterval(() => {
        //.log("Recursive running the table loading");
        if (currentRaceProps.curRace != null) {
          this.requestTimeOdds(currentRaceProps.curRace, currentRaceProps.curRacers)
        }
      }, this.defaultTimer)

      this.winnerTimer = setInterval(() => {
        //console.log("Recursive running the table loading");
        if (currentRaceProps.curRace != null) {
          this.requestWinnerInfo(currentRaceProps.curRace)
        }
      }, this.winnerTimerSetting)
    } else {
      if (this.timer !== null) clearInterval(this.timer)
      if (this.winnerTimer !== null) clearInterval(this.winnerTimer)
    }
  }


  updateBoards(newEle) {
    //console.log("Update Boards called " + newEle);
    this.setState(prevState => ({
      boards: [...prevState.boards, newEle]
    }))
  }

  getRunnerName(selectionId, curenntRacers) {
    var name = "Unknown"
    curenntRacers.map(runner => {
      //console.log("Runner TH Name " + runner.runnerName)
      //console.log("Runner TH selectionId " + runner.selectionId)

      if (runner.selectionId == selectionId) {
        //console.log("Runner THHHHH Name " + runner.runnerName)
        name = runner.runnerName
      }
    }
    )
    return name
  }

  getRunnerMetadata(selectionId, curenntRacers) {
    var name = null
    curenntRacers.map(runner => {
      if (runner.selectionId == selectionId) {
        name = runner.metadata
      }
    }
    )
    return name
  }

  getTimeDiffInMins(timeDiff) {
    var hours = parseInt(timeDiff.substring(0, 2))
    var mints = parseInt(timeDiff.substring(3, 5))

    return (hours * 60 + mints)

  }

  requestWinnerInfo = currentRace => {
    const endpoint = API_WINNER + currentRace.date + "/" + currentRace.marketId
    //console.log(`requestWinnerInfo: ${endpoint}`)
    axios.get(endpoint)
      .then((res) => {
        //console.log("requestWinnerInfo. Result of API Winner ::" + res.data)
        responseBody = res.data
        const currentState = { ...this.state }
        currentState.winnerInfo = responseBody
        currentState.marketId = currentRace.marketId

        this.setState(currentState)
      },
        (error) => {
          //console.log("requestWinnerInfo. Error occurred when reading Winner info")
        });
  }

  requestVerdict = currentRace => {
    const localTime = moment(currentRace.date + ' ' + currentRace.time, 'YYYYMMDD HH:mm')
      .add(60, 'minutes')
      .format('HH:mm')
    const venue = currentRace.venue.replace(/ /g, '-')
    const endpoint = `https://rdbwebapi.makebettinggreat.com/v1/verdict/${currentRace.date}/${localTime}/${venue}`
    axios.get(endpoint)
      .then((res) => {
        this.setState({ verdict: res.data.verdicts })
      })
      .catch(() => {
        this.setState({ verdict: null })
      })
  }

  requestTimeOdds(currentRace, currentRacers) {
    var th = this;
    let TObj = {}

    Object.keys(store.getState().isExactTimeSelected).map(timeEle => {
      if (store.getState().isExactTimeSelected[timeEle] == "exact") {
        //Extract race date.
        var raceDate = store.getState().currentRaceTime.substring(0, 8);
        TObj[timeEle] = moment(raceDate + " " + store.getState().exactTimeSettings[timeEle], 'YYYYMMDD HH:mm')
          .format('YYYYMMDD-HH:mm:ss');
      } else if (store.getState().isExactTimeSelected[timeEle] == "diff") {
        TObj[timeEle] = moment(store.getState().currentRaceTime, 'YYYYMMDD HH:mm').subtract(parseInt(this.getTimeDiffInMins(store.getState().timeSettings[timeEle])), 'minutes').format('YYYYMMDD-HH:mm:ss');
      }
    }
    )

    var timePointsArray = ["t1-" + TObj.t1, "t2-" + TObj.t2, "t3-" + TObj.t3, "t4-" + TObj.t4, "t5-" + TObj.t5, "t6-" + TObj.t6]

    const requiredLatestTimeStamp = moment(store.getState().currentRaceTime, 'YYYYMMDD HH:mm').subtract(parseInt(store.getState().latestOddsSettings.noOfSeconds), 'seconds').format('YYYYMMDD-HH:mm:ss');

    postRequestPara.marketIds = [store.getState() && store.getState().betMarket ? store.getState().betMarket.marketId : currentRace.marketId]
    postRequestPara.timePoints = timePointsArray
    postRequestPara.tickUntilKickoff = store.getState().latestOddsSettings.tickUntilActualStart === "yes" ? true : false
    postRequestPara.latestTimeStamp = requiredLatestTimeStamp
    window.postRequest = postRequestPara
    // Fetch predictions independently (non-blocking) - odds render first, AI Rank updates when this completes
    this.serverRequestPred =
      axios.post("https://rpmai.makebettinggreat.com/probability/v4/market",
        postRequestPara)
        .then((res) => {
          console.log("Prediction API response:", res.data)
          console.log("Type of res.data:", typeof res.data)

          // Parse response if it's a string
          let data = res.data
          if (typeof res.data === 'string') {
            try {
              // Replace NaN with null since NaN is not valid JSON
              const cleanedData = res.data.replace(/:\s*NaN/g, ': null')
              data = JSON.parse(cleanedData)
              console.log("Parsed JSON successfully:", data)
            } catch (e) {
              console.error("Failed to parse JSON:", e)
              console.error("Original data:", res.data)
              return
            }
          }

          console.log("Has runners property?", data && data.runners ? "YES" : "NO")
          const predictions = {}
          if (data && data.runners) {
            data.runners.forEach((runner, index) => {
              // Extract all required fields from API
              const backOddChangeT0T2 = parseFloat(runner.back_odd_change_t0_t2) || 0
              const backOddChangeT0T3 = parseFloat(runner.back_odd_change_t0_t3) || 0
              const totalJockeyTrainerWinPct = parseFloat(runner.total_jockey_trainer_win_pct) || 0
              const fppRating = parseFloat(runner.fpp_rating) || 0
              const aprRating = parseFloat(runner.apr_rating) || 0

              // Calculate composite probability using formula
              const calculatedProbability =
                (0.35 * backOddChangeT0T2) +
                (0.25 * backOddChangeT0T3) +
                (0.15 * totalJockeyTrainerWinPct) +
                (0.15 * fppRating) +
                (0.10 * aprRating)

              predictions[runner.selectionId] = {
                win_probability: runner.win_probability,
                predictionRank: index + 1,  // Use array position as rank (already sorted)
                calculated_probability: calculatedProbability,
                back_odd_change_t0_t2: backOddChangeT0T2,
                back_odd_change_t0_t3: backOddChangeT0T3,
                total_jockey_trainer_win_pct: totalJockeyTrainerWinPct,
                fpp_rating: fppRating,
                apr_rating: aprRating
              }
            })
            // Calculate calculated_rank based on calculated_probability
            const sortedByCalcProb = Object.entries(predictions)
              .sort((a, b) => b[1].calculated_probability - a[1].calculated_probability)

            sortedByCalcProb.forEach(([selectionId, data], index) => {
              predictions[selectionId].calculated_rank = index + 1
            })

          } else {
            console.warn("Invalid data structure - runners not found or not an array. data:", data)
          }
          // Update state with new predictions and re-render with current odds
          this.setState({ predictions }, () => {
            const currentOdds = this.state.runnersOddsAtTimes
            if (currentOdds && currentOdds.length > 0) {
              // Directly patch prediction data into existing odds rows — avoids re-running
              // getMarketOddsForTimesTest which can fail if responseBody is not fully ready
              const updated = currentOdds.map(runner => {
                const pred = predictions[runner.selectionId]
                if (pred && runner.status === 'ACTIVE' && pred.win_probability) {
                  return {
                    ...runner,
                    predictionRank: pred.predictionRank,
                    win_probability: pred.win_probability,
                    calculated_probability: pred.calculated_probability,
                    calculated_rank: pred.calculated_rank,
                    back_odd_change_t0_t2: pred.back_odd_change_t0_t2,
                    back_odd_change_t0_t3: pred.back_odd_change_t0_t3,
                    total_jockey_trainer_win_pct: pred.total_jockey_trainer_win_pct,
                    fpp_rating: pred.fpp_rating,
                    apr_rating: pred.apr_rating,
                  }
                }
                return runner
              })
              this.setState({ runnersOddsAtTimes: updated })
            }
            // If odds haven't arrived yet (runnersOddsAtTimes empty), the odds callback will
            // read this.state.predictions when it fires and apply rank at that point
          })
        },
          (error) => {
            console.log("Error fetching predictions:", error)
          });

    // Fetch odds immediately without waiting for predictions
    this.serverRequest =
      axios.post(API2, postRequestPara)
        .then((res) => {
          //console.log("Result of API 2 ::" + res.data)
          responseBody = res.data
          window.response = res.data
          // Use current predictions from state (could be cached or empty)
          let allArray = this.getMarketOddsForTimesTest(currentRacers, this.state.predictions || {})
          window.allArray = allArray
          this.setState({
            currentRace: {
              ...currentRace,
              latestOddTimestamp: window.latestOddTimestamp
            },
            currentRacers: currentRacers,
            runnersOddsAtTimes: allArray,
          })
        },
          (error) => {
            let allArray = this.getMarketOddsForTimesTest(currentRacers, this.state.predictions || {})
            this.setState({
              currentRace: {
                ...currentRace,
                latestOddTimestamp: window.latestOddTimestamp
              },
              currentRacers: currentRacers,
              runnersOddsAtTimes: allArray,
            })
          });
  }

  getMarketOddsForTimesTest(currentRacers, prediction) {

    var temp = {}
    var runnerName = ""
    var selectionId = ""
    var runnerMetaData = {}
    var toOdds = []
    var toOdds_tmp = []
    toOdds_tmp = [responseBody.marketOdds[0].t0.runnerOdds][0]
    window.latestOddTimestamp = responseBody.marketOdds[0].t0.timeStamp;

    toOdds_tmp.forEach(function (odd) {
      if (odd.bestBackOdd === null) {
        toOdds.push(odd);
      } else {
        toOdds.unshift(odd);
      }
    });

    toOdds.sort((a, b) => (a.bestBackOdd != null ? a.bestBackOdd : Infinity) - (b.bestBackOdd != null ? b.bestBackOdd : Infinity))

    //toOdds.sort((a, b) => (a.bestBackOdd === null) ? 1 : -1)
    //toOdds.sort((a, b) => (a.bestBackOdd > b.bestBackOdd) ? 1 : -1)

    window.toOdds = toOdds
    //console.log("Sorted time slots :: " + toOdds[0].bestBackOdd)
    //console.log("getMarketOddsForTimesTest: " + window.latestOddTimestamp)

    toOdds.map((item, key) => {
      //console.log("Runner Odd : selectionId : " + item.selectionId + " bestBackOdd :" + item.bestBackOdd)
      // First try to get runner name from the odds data itself, then fall back to lookup
      runnerName = this.getRunnerName(item.selectionId, currentRacers)
      runnerMetaData = this.getRunnerMetadata(item.selectionId, currentRacers)
      temp[item.selectionId] = {}
      temp[item.selectionId].currentPrice = item.bestBackOdd
      temp[item.selectionId].volumeMatched = item.volumeMatched
      //console.log("Runner Name set for selectionId " + item.selectionId + " :: " + runnerName);
      temp[item.selectionId].name = runnerName
      temp[item.selectionId].metadata = runnerMetaData
      temp[item.selectionId].status = item.status
      temp[item.selectionId].selectionId = item.selectionId


      // Add prediction data if available
      if (prediction && prediction[item.selectionId]) {
        const predData = prediction[item.selectionId]
        const winProb = predData.win_probability
        if (winProb) {
          temp[item.selectionId].win_probability = predData.win_probability
          temp[item.selectionId].predictionRank = predData.predictionRank
          temp[item.selectionId].calculated_probability = predData.calculated_probability
          temp[item.selectionId].calculated_rank = predData.calculated_rank
          temp[item.selectionId].back_odd_change_t0_t2 = predData.back_odd_change_t0_t2
          temp[item.selectionId].back_odd_change_t0_t3 = predData.back_odd_change_t0_t3
          temp[item.selectionId].total_jockey_trainer_win_pct = predData.total_jockey_trainer_win_pct
          temp[item.selectionId].fpp_rating = predData.fpp_rating
          temp[item.selectionId].apr_rating = predData.apr_rating
        }
      }
    })

    let times = ["t1", "t2", "t3", "t4", "t5", "t6"]
    times.map(tVal => {
      if (responseBody.marketOdds[0][tVal] != null && responseBody.marketOdds[0][tVal].runnerOdds) {
        responseBody.marketOdds[0][tVal].runnerOdds.map(runnerOdd => {
          if (runnerOdd.bestBackOdd != null) {
            temp[runnerOdd.selectionId][tVal + 'Price'] = runnerOdd.bestBackOdd
            temp[runnerOdd.selectionId][tVal] = parseInt((runnerOdd.bestBackOdd - temp[runnerOdd.selectionId].currentPrice) * 100 / runnerOdd.bestBackOdd) + '%'
          } else {
            //console.log("Best back odd is null .");
            temp[runnerOdd.selectionId][tVal + 'Price'] = "n/a"
            temp[runnerOdd.selectionId][tVal] = 'n/a'
          }
        })
      } else {
        responseBody.marketOdds[0].t0.runnerOdds.map(runnerOdd => {
          //console.log("Runner Null Odd :  TVal" + tVal + " Selection ID:" + runnerOdd.selectionId)
          temp[runnerOdd.selectionId][tVal + 'Price'] = "n/a"
          temp[runnerOdd.selectionId][tVal] = 'n/a'
        })
      }
    })

    //console.log("EREE " + this.state.runnersOddsAtTimes)
    var finalOdds = []

    Object.keys(temp).map(runnerElement => {
      //console.log("********" + JSON.stringify(temp[runnerElement]))
      if (temp[runnerElement].name != "Unknown") {
        finalOdds.push(temp[runnerElement])
      }
    }
    )

    finalOdds.sort((a, b) => (a.currentPrice != null ? a.currentPrice : Infinity) - (b.currentPrice != null ? b.currentPrice : Infinity))

    //filter unknown

    // Recalculate predictionRank only for ACTIVE runners
    const activeRunners = finalOdds.filter(runner => runner.status === 'ACTIVE' && runner.predictionRank)
    activeRunners.sort((a, b) => a.predictionRank - b.predictionRank)

    // Reassign ranks sequentially to active runners only
    activeRunners.forEach((runner, index) => {
      runner.predictionRank = index + 1
    })

    // Remove predictionRank from non-active runners
    finalOdds.forEach(runner => {
      if (runner.status !== 'ACTIVE') {
        delete runner.predictionRank
      }
    })

    window.myStateObject = finalOdds
    return finalOdds
  }

  componentDidUpdate() {
    if (currentRaceProps.curRace != null) {
      //console.log("componentDidUpdate: " + currentRaceProps.curRace.date + ":" + currentRaceProps.curRace.time + " : " + this.props.tabSelected);
      const currentGmtTime = moment();
      const raceTimeGmt = moment((currentRaceProps.curRace.date + " " + currentRaceProps.curRace.time), 'YYYYMMDD HH:mm').add(store.getState().localTimeOffSetToGmt, 'minutes');
      const timeDiffInMin = (raceTimeGmt.unix() - currentGmtTime.unix()) / 60
      const switchToIntensiveMode = (timeDiffInMin < this.INTENSE_MINUTE_SETTING) && (timeDiffInMin > 0);
      //console.log(`componentDidUpdate: currentGmtTime: ${currentGmtTime}, raceTimeGmt: ${raceTimeGmt}, switchToIntensiveMode: ${switchToIntensiveMode}, currentModeIntensive: ${this.intensiveMode}, timeDiffInMin: ${timeDiffInMin}`);
      if (this.props.tabSelected === "RacesNRunners") {
        if (switchToIntensiveMode && !this.intensiveMode) {
          this.intensiveMode = true;
          clearInterval(this.timer);
          this.timer = setInterval(() => {
            //console.log("Recursive running the table loading with default mode");
            if (currentRaceProps.curRace != null) {
              this.requestTimeOdds(currentRaceProps.curRace, currentRaceProps.curRacers)
            }
          }, this.highSpeedTimer)
        } else if (switchToIntensiveMode && this.intensiveMode) {
          //Do nothing altready running in intensive mode

        } else if (!switchToIntensiveMode && this.intensiveMode) {
          this.intensiveMode = false;
          clearInterval(this.timer);
          this.timer = setInterval(() => {
            //console.log("Recursive running the table loading with intensive mode");
            if (currentRaceProps.curRace != null) {
              this.requestTimeOdds(currentRaceProps.curRace, currentRaceProps.curRacers)
            }
          }, this.defaultTimer)
        } else {
          clearInterval(this.timer);
          this.timer = setInterval(() => {
            //console.log("Recursive running the table loading with default mode");
            if (currentRaceProps.curRace != null) {
              this.requestTimeOdds(currentRaceProps.curRace, currentRaceProps.curRacers)
            }
          }, this.defaultTimer)
        }
      } else {
        if (this.timer !== null) clearInterval(this.timer)
      }
    }
  }

  onMarketChange = () => {
    if (currentRaceProps.curRace != null) {
      this.setState({ predictions: {} })
      this.requestTimeOdds(currentRaceProps.curRace, currentRaceProps.curRacers)
    }
  }

  requestAiRankStats = (curRace) => {
    if (!curRace || !curRace.date) return
    axios.get(API_AI_RANK_STATS + curRace.date)
      .then(res => {
        const stats = res.data
        if (!stats || stats.length === 0) return
        const countryStat = stats.find(s => s.country === curRace.country)
        store.dispatch(updateAiRankStats(countryStat || null))
      })
      .catch(() => store.dispatch(updateAiRankStats(null)))
  }

  updateStateOfBoards = (curRace, curRacers) => {
    window.currentRace = curRace
    //console.log("updateStateOfBoards : " + JSON.stringify(curRace))
    currentRaceProps.curRace = curRace
    currentRaceProps.curRacers = curRacers
    responseBody = { "marketOdds": [] }
    this.setState({
      currentRace: [],
      currentRacers: [],
      runnersOddsAtTimes: [],
      predictions: {},
      winnerInfo: null,
      verdict: null
    })
    store.dispatch(updateAiRankStats(null))
    store.dispatch(updateBetMarket({ "marketId": curRace.marketId, "type": 'Win' }));
    if (currentRaceProps.curRace != null) {
      this.requestTimeOdds(currentRaceProps.curRace, currentRaceProps.curRacers)
      this.requestWinnerInfo(currentRaceProps.curRace)
      this.requestVerdict(currentRaceProps.curRace)
      this.requestAiRankStats(currentRaceProps.curRace)
    }

  }


  render() {


    var element1 = { firstCurrency: "sdsd", firstVal: "20", secondCurrency: "YUAN", secondVal: "245" }

    let t1 = store.getState().isExactTimeSelected.t1 == "exact" ? getRealTimeinHHMMFormat("t1") : getTimeDiffInMins(store.getState().timeSettings.t1) + " mins before start race"
    let t2 = store.getState().isExactTimeSelected.t2 == "exact" ? getRealTimeinHHMMFormat("t2") : getTimeDiffInMins(store.getState().timeSettings.t2) + " mins before start race"
    let t3 = store.getState().isExactTimeSelected.t3 == "exact" ? getRealTimeinHHMMFormat("t3") : getTimeDiffInMins(store.getState().timeSettings.t3) + " mins before start race"
    let t4 = store.getState().isExactTimeSelected.t4 == "exact" ? getRealTimeinHHMMFormat("t4") : getTimeDiffInMins(store.getState().timeSettings.t4) + " mins before start race"
    let t5 = store.getState().isExactTimeSelected.t5 == "exact" ? getRealTimeinHHMMFormat("t5") : getTimeDiffInMins(store.getState().timeSettings.t5) + " mins before start race"
    let t6 = store.getState().isExactTimeSelected.t6 == "exact" ? getRealTimeinHHMMFormat("t6") : getTimeDiffInMins(store.getState().timeSettings.t6) + " mins before start race"

    //console.log(" current race time " + this.state.currentRace["time"] + " venue " + this.state.currentRace["venue"]);
    return (
      <div class="backcolr">
        <Row className="MiddleRow">
          <Col style={{ paddingRight: '0px', paddingLeft: '10px' }} sm={2}>
            <CollapsibleList updateBoards={this.updateStateOfBoards.bind(this)} selectedDate={this.props.selectedDate} />
          </Col>
          <Col style={{ paddingRight: '10px', paddingLeft: '0px' }} sm={10}>
            <Row className="SecondMiddleRow" style={{ marginLeft: '0', marginRight: '0' }}>
              <Col style={{ paddingRight: '0', paddingLeft: '0' }}>
                <div class="divStyle10 boxSize3 borderStyle">
                  <RightTable marketId={this.state.marketId}
                    winnerInfo={this.state.winnerInfo}
                    firstItem={this.state.currentRace}
                    secondItem={this.state.runnersOddsAtTimes}
                    defaultMarket={'Win'}
                    displayTicks={this.props.displayTicks}
                    displayResult={this.props.displayResult}
                    onMarketChange={this.onMarketChange}
                    verdict={this.state.verdict} />
                </div>
              </Col>
            </Row>
            <Row>
              <Col>
                <div class="divStyle10 boxSize4 borderStyle">
                  <Row className="ThirdMiddleRow">
                    <Col sm={9}>
                      <Row>
                        <Col><div class="divsd3"><span class="alignItems1">T1: {t1}</span></div></Col>
                        <Col><div class="divsd3"><span class="alignItems1">T2: {t2}</span></div></Col>
                        <Col><div class="divsd3"><span class="alignItems1">T3: {t3}</span></div></Col>
                      </Row>
                      <Row>
                        <Col><div class="divsd3"><span class="alignItems1">T4: {t4}</span></div></Col>
                        <Col><div class="divsd3"><span class="alignItems1">T5: {t5}</span></div></Col>
                        <Col><div class="divsd3"><span class="alignItems1">T6: {t6}</span></div></Col>
                      </Row>
                    </Col>
                    <Col sm={3}>
                      <div class="divsd"><span class="alignItems1">Display TimeZone - {store.getState().localTimeZone}</span></div>
                    </Col>
                  </Row>
                </div>
              </Col>
            </Row>
          </Col>
        </Row>

      </div>

    )
  }
}

export default CurrencyBoard
